import { useRef } from "react";

import { RESEND_PATIENT_PAY_CHECKOUT_LINK_MUTATION } from "@/graphql/patientPay";
import ChevronComponent from "@/tpo/Chevron";
import { IndicativeButton } from "@/v2/Buttons";
import { useMutation } from "@apollo/client";

export default function PatientPayResendLinkButton({ orderId }) {
  const buttonRef = useRef();

  const [resendCheckoutLink] = useMutation(RESEND_PATIENT_PAY_CHECKOUT_LINK_MUTATION, {
    onCompleted: () => {
      buttonRef.current.setSuccessful(true);
      buttonRef.current.setPending(false);
    },
    onError: () => {
      buttonRef.current.setSuccessful(false);
      buttonRef.current.setPending(false);
    },
    variables: {
      input: {
        orderId
      }
    }
  });

  return (
    <IndicativeButton
      ref={buttonRef}
      defaultColor="green"
      pendingColor="darkgrey"
      successColor="#2ecc71"
      failureColor="error"
      rightIcon={<ChevronComponent />}
      type="button"
      onClick={resendCheckoutLink}
      size={["sm", "sm", "md"]}
    >
      Email me a new link
    </IndicativeButton>
  );
}
